import { render, staticRenderFns } from "./newresult.vue?vue&type=template&id=3dba2388&scoped=true"
import script from "./newresult.vue?vue&type=script&lang=js"
export * from "./newresult.vue?vue&type=script&lang=js"
import style0 from "./newresult.vue?vue&type=style&index=0&id=3dba2388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba2388",
  null
  
)

export default component.exports